import { ShowingTagDto } from '@cineamo/api/models/showing-tag/ShowingTagDto.types';

import { ShowingTagListResponse } from '@cineamo/api/types/ApiListResponse.types';
import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { API_URL } from '@/constants/http-constants';

import apiClient from '@/utils/api/cineamoApiClient';

import { buildUrlQuery, UrlQueryParameter } from '@/helpers/url-query-helper';

export type GetShowingTagsQuery = UrlQueryParameter & {
    cinemaIds?: number[] | string[];
    showingIds?: number[] | string[];
    hasShowings?: boolean;
    showingStartDatetime?: string;
    showingEndDatetime?: string;
};

export async function getShowingTags(
    query: GetShowingTagsQuery
): Promise<ApiResponse<unknown, ShowingTagListResponse> | null> {
    return await apiClient
        .get<ApiResponse<unknown, ShowingTagListResponse>>(`${API_URL}/showing-tags${buildUrlQuery(query)}`)
        .then((response) => response)
        .catch(() => {
            return null;
        });
}

export async function getShowingTagById(showingTagId: number | string): Promise<ApiResponse<ShowingTagDto> | null> {
    return await apiClient
        .get<ApiResponse<ShowingTagDto>>(`${API_URL}/showing-tags/${showingTagId}`)
        .then((response) => response)
        .catch(() => {
            return null;
        });
}
